/** File detail görünümünde global tema her zaman internal (yeşil) kalır. */
type Listener = () => void;

let active = false;
const listeners = new Set<Listener>();

export function setFileDetailThemeOverride(value: boolean): void {
  if (active === value) return;
  active = value;
  listeners.forEach((listener) => listener());
}

export function getFileDetailThemeOverride(): boolean {
  return active;
}

export function subscribeFileDetailThemeOverride(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
